(function (global) {
  'use strict';
  if (global.FlorameAddressTracking) return;
  const endpoint = 'https://us-central1-flower-ai-2d7aa.cloudfunctions.net/logAddressAttempt';
  const uuid = () => global.crypto?.randomUUID?.() || `${Date.now().toString(36)}_${Math.random().toString(36).slice(2)}`;
  let sessionId = uuid();
  try {
    sessionId = global.localStorage.getItem('florame_cap_session_id') || sessionId;
    global.localStorage.setItem('florame_cap_session_id', sessionId);
  } catch (_) {}
  const pending = new Map();
  function send(payload) {
    const body = { ...payload, sessionId: payload.sessionId || sessionId };
    if (!body.customerEmail) body.customerEmail = String(global.AWI_CUSTOMER_EMAIL || global.__AWI_CUSTOMER_EMAIL || '').trim().toLowerCase();
    // Snapshot the event: retries must never become new attempts or change its date.
    body.eventId = body.eventId || uuid();
    body.occurredAtMs = body.occurredAtMs || Date.now();
    const encoded = JSON.stringify(body);
    if (encoded.length > 16000) return;
    const entry = { encoded, retries: 0 };
    pending.set(body.eventId, entry);
    async function deliver() {
      try {
        const response = await global.fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: encoded, keepalive: true });
        const result = await response.json();
        if (!response.ok || result?.success !== true) throw new Error('tracking_unavailable');
        pending.delete(body.eventId);
      } catch (_) {
        if (entry.retries++ < 2) global.setTimeout(deliver, 1000 * entry.retries);
        else pending.delete(body.eventId);
      }
    }
    void deliver();
  }
  function begin(payload = {}) {
    const path = String(global.location?.pathname || '/').replace(/^\/(en|it)(?=\/|$)/, '') || '/';
    const isCreate = /(?:\?|&)mode=create(?:&|$)/.test(String(global.location?.search || ''));
    const isFlorist = global.document?.documentElement?.hasAttribute?.('data-florame-partner-storefront');
    const context = isCreate || /custom|crea/.test(path) ? 'create' : isFlorist ? 'florist' : path === '/' || /florame-app/.test(path) ? 'home' : /cart/.test(path) ? 'cart' : /profile|account/.test(path) ? 'account' : /products/.test(path) ? 'product' : /partner|fiorist/.test(path) ? 'florist' : 'storefront';
    const base = { ...payload, source: payload.source || 'delivery-intent', context: payload.context || context, attemptId: uuid() };
    send({ ...base, status: 'start', isAddress: null });
    return { finish(result) { send({ ...base, ...result }); } };
  }
  // Keep only in-flight data in memory. No address/email queue survives logout.
  global.addEventListener?.('pagehide', () => {
    for (const { encoded } of pending.values()) {
      try { global.navigator.sendBeacon?.(endpoint, new Blob([encoded], { type: 'application/json' })); } catch (_) {}
    }
  });
  global.FlorameAddressTracking = Object.freeze({ send, begin });
})(window);
